import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AdminAuthGuard,
  AuthGuard,
  DeviceManagerAuthGuard,
} from '../auth/_guards';
import { ThemeComponent } from './theme.component';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    component: ThemeComponent,
    children: [
      {
        path: 'users',
        canActivate: [AdminAuthGuard],
        loadChildren: './eacds/users/user.module#UserModule',
      },
      {
        path: 'settings',
        canActivate: [AdminAuthGuard],
        loadChildren: './eacds/settings/settings.module#SettingsModule',
      },
      {
        canActivate: [AuthGuard],
        loadChildren: './eacds/users/useracc.module#UserAccModule',
        path: 'userAcc',
      },
      {
        canActivate: [DeviceManagerAuthGuard],
        loadChildren: './eacds/devices/device.module#DeviceModule',
        path: 'devices',
      },
      {
        loadChildren: './eacds/groups/group.module#GroupModule',
        path: 'groups',
      },
      {
        loadChildren: './eacds/contents/content.module#ContentModule',
        path: 'contents',
      },
      {
        loadChildren:
          './eacds/header/header-actions/header-actions.module#HeaderActionsModule',
        path: 'header/actions',
      },
      {
        loadChildren:
          './eacds/header/header-profile/header-profile.module#HeaderProfileModule',
        path: 'header/profile',
      },
      {
        canActivate: [AdminAuthGuard],
        loadChildren: './eacds/reports/reports.module#ReportsModule',
        path: 'reports',
      },
      {
        canActivate: [DeviceManagerAuthGuard],
        loadChildren:
          './eacds/reports/device-reports.module#DeviceReportsModule',
        path: 'device-reports',
      },
      {
        canActivate: [AdminAuthGuard],
        loadChildren:
          './eacds/applications/applications.module#ApplicationsModule',
        path: 'applications',
      },
      {
        loadChildren: './eacds/index/index.module#IndexModule',
        path: 'cloud-activation',
      },
      {
        loadChildren: './eacds/error/not-found/not-found.module#NotFoundModule',
        path: '404',
      },
      {
        loadChildren: './eacds/index/index.module#IndexModule',
        path: 'index',
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'index',
      },
    ],
    path: '',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '404',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class ThemeRoutingModule { }
